<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon left>mdi-clipboard-text</v-icon>Purchase Orders (SkuVault)
            </v-toolbar-title>
            <template v-slot:extension>
              <v-tabs v-model="tabs">
                <v-tab>Cancelled</v-tab>
                <v-tab>NoneReceived</v-tab>
                <v-tab>PartiallyReceived</v-tab>
                <v-tab>Completed</v-tab>
                <v-tab>All</v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
                <po-table :defaultFilter="{sentStatus:'Cancelled', skuVault:1}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
                <po-table :defaultFilter="{sentStatus:'NoneReceived', skuVault:1}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
                <po-table :defaultFilter="{sentStatus:'PartiallyReceived', skuVault:1}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
                <po-table :defaultFilter="{sentStatus:'Completed', skuVault:1}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
                <po-table :defaultFilter="{skuVault:1}" :headers="headers" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import PoTable from "@components/purchaseOrder/PoTable"
export default {
  components: {
    PoTable,
  },
  data: () => ({
    tabs:null,
    headers: [
            { text: "PO Number", value: "poNumber", align: "left" },
            { text: "Sent Status", value: "sentStatus", align: "left" },
            { text: "Currency", value: "currency", align: "left" },
            { text: "Order Date", value: "orderDate", align: "left" },
            { text: "Payment Status", value: "paymentStatus" },
            { text: "Notes", value: "publicNotes", align: "left" },
            { text: "Carrier", value: "shippingCarrier", align: "left" },
            { text: "Supplier", value: "supplier.name", align: "left" },
            { text: "Action", value: "action", align: "left" }
        ]
  })
};
</script>
